<template>
  <CModal class="modal-chooseFile addSchedule" title="Danh sách tập tin âm thanh từ kho biên tập" :show.sync="isShowModal"
    :closeOnBackdrop="false" :size="'xl'">
    <div id="fileManagementAddSchedule">
      <CRow class="mb-3 search-panel">
        <CCol xs="12" sm="6" md="3" lg="2" xl="2">
          <div class="form-group">
            <label for="datepicker">Từ ngày - đến ngày</label>
            <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
              locale="vi" is-range class="datepicker" :popover="{ visibility: 'click' }">
              <template v-slot="{ inputValue, inputEvents }">
                <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                  class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
              </template>
            </DatePicker>
          </div>
        </CCol>
        <CCol xs="12" sm="6" md="3" lg="2" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
          <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
          </BaseSelect>
        </CCol>
        <CCol xs="12" sm="6" md="3" lg="2" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
          <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
        </CCol>
        <!-- <CCol xs="12" sm="4" md="4" lg="4" xl="2">
          <BaseSelect :options="typeFileSelect.options" :data="typeFileSelect.data" ref="typeFileSelect">
          </BaseSelect>
        </CCol> -->
        <CCol xs="12" sm="6" md="3" lg="2" xl="2">
          <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
        </CCol>
        <CCol xs="12" sm="6" md="3" lg="2" xl="2" class="search-action-col ml-auto">
          <div class="form-group mb-0">
            <label class="search-action-label"></label>
            <div class="search-action-wrap">
              <CButton color="primary" v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary search-action-btn" @click="reloadData()">
                <i class="fa fa-refresh"></i>&nbsp; Tải lại
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
      <CCard class="content-fade-in mt-3p5">
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            @row-click="rowClickTable($event)" ref="mainTable">
            <template #index="{ index, item }">
              <td class="action-btn-group">
                <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id"
                  name="fileAddScheduleSelected" :key="'file-radio-' + item.id + '-' + String(selectionIdForCompare)"
                  :checked="isItemSelected(item)" />
              </td>
            </template>
            <template #createDate="{ item }">
              <td v-if="item.createDate != null">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </td>
              <td v-else></td>
            </template>
            <template #description="{ item }">
              <td>
                <span v-if="item.description" :key="item.description" class="description"
                  v-c-tooltip.hover="item.description">
                  {{ item.description }}
                </span>
              </td>
            </template>
            <template #type="{ item }">
              <td>
                <span class="badge badge-light" v-if="item.type == 0">Biên tập</span>
                <span class="badge badge-light" v-else-if="item.type == 1">Chuyển đổi văn bản</span>
                <span class="badge badge-light" v-else-if="item.type == 2">Ghi âm tệp tin</span>
                <span class="badge badge-light" v-else-if="item.type == 3">Ghép tệp tin</span>
              </td>
            </template>
            <template #title="{ item }">
              <td>{{ item.title }}</td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id" name="test"
                  :checked="item.checked" />
              </td>
            </template>
          </BaseTable>
        </CCardBody>
      </CCard>

      <BaseModal :title="'Xem tệp tin: ' + previewModel.title" :show.sync="previewModel.isShowModal"
        :closeOnBackdrop="false">
        <template v-slot:body-wrapper>
          <div class="modal-body content-fade-in">
            <audio :src="previewModel.url" controls autoplay style="width: 100%" ref="previewAudio"></audio>
          </div>
        </template>
        <template v-slot:footer>
          <div slot="footer">
            <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i class="fa fa-close"></i>
              Đóng
            </button>&nbsp;
          </div>
        </template>
      </BaseModal>

    </div>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary" :disabled="itemChooseFileSelected == ''"
        @click="submitSelectedChooseFile()">
        <i class="fa fa-check"></i> Chọn
      </button>
      <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
      </button>
    </template>
  </CModal>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseModal from "@/views/base/BaseModal";
import { DatePicker } from "v-calendar";
import VideoPlayer from "@/views/base/VideoPlayer";

export default {
  name: "FileManagementAddSchedule",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      isSelectedAllDevices: false,
      isShowModal: true,
      loading: {
        value: false,
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: ''
      },
      actionData: {
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      typeFileSelect: {
        options: {
          filter: true,
          label: "Loại tệp tin",
          selectAllText: "Tất cả loại tệp tin",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "type",
          model: '',
          items: [
            { key: '0', value: 'Biên tập' },
            { key: '1', value: 'Chuyển đổi văn bản' },
            { key: '2', value: 'Ghi âm tệp tin' },
            { key: '3', value: 'Ghép tệp tin' },
          ],

        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
        },
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "#", sorter: false, filter: false },
            { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
            { key: "title", label: "Tiêu đề" },
            { key: "duration", label: "Thời lượng" },
            { key: "description", label: "Mô tả", sorter: false, filter: false },
            { key: "locationName", label: "Địa bàn" },
            { key: "fileTypeName", label: "Lĩnh vực" },
            // {key: "url", label: "Nội dung bản tin", sorter: false, filter: false},
            { key: "type", label: "Loại tệp tin", sorter: true, filter: false },
            // {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: [
            "index", "createDate", "action", "url", "type", "description"
          ],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: true,
          itemsPerPageSelect: { label: ' ', values: [10, 15, 20, 50], external: true },
          pageSize: 20,
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false },
        },
        dataSource: {
          url: "/file-management/getPages",
          dataSubmit: () => {
            const params = {
              districtCode: this.normalizeFilterValue(this.districtCodeInput.data.model),
              wardCode: this.normalizeFilterValue(this.wardCodeInput.data.model),
              type: this.normalizeFilterValue(this.typeFileSelect.data.model),
              locationCode: this.normalizeFilterValue(this.locationCode.data.model),
              name: this.titleInput && this.titleInput.data ? this.titleInput.data.model : "",
            };
            params.fromDate = this.$helper.formatDateDDMMYYYY(this.dateRange.start);
            params.toDate = this.$helper.formatDateDDMMYYYY(this.dateRange.end);
            params.status = 2;
            return params;
          },
          response: (dataResponse) => dataResponse.data
        }
      },
      itemChooseFileSelected: '',
      reloadTimer: null
    };
  },
  methods: {
    normalizeFilterValue(value) {
      return (value === null || value === undefined || value === '') ? null : String(value);
    },
    loadDataFile(resetSelection = false) {
      if (resetSelection) {
        this.itemChooseFileSelected = '';
      }
      if (this.$refs.mainTable) {
        this.$refs.mainTable.loadData(false);
      }
    },
    reloadData() {
      this.loadDataFile(true);
    },
    scheduleReload() {
      if (this.reloadTimer) {
        clearTimeout(this.reloadTimer);
      }
      this.reloadTimer = setTimeout(() => {
        this.reloadTimer = null;
        this.reloadData();
      }, 0);
    },
    rowClickTable(payload) {
      const item = payload && payload.item ? payload.item : payload;
      this.itemChooseFileSelected = item;
    },
    isItemSelected(item) {
      const sid = this.selectionIdForCompare;
      return (
        sid !== null &&
        sid !== undefined &&
        sid !== '' &&
        String(item.id) === String(sid)
      );
    },
    submitSelectedChooseFile() {
      if (this.itemChooseFileSelected == null || this.itemChooseFileSelected == '') {
        return;
      }
      this.$emit('file:selected', this.itemChooseFileSelected);
    },
    viewFile(title, url) {
      this.previewModel.url = url;
      this.previewModel.isShowModal = true;
      this.previewModel.title = title;
    },
    closePreviewAudio() {
      this.$refs.previewAudio.pause();
      this.previewModel.isShowModal = false;
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataFile();
    this.$nextTick(() => {
      if (this.$refs.wardCodeInput) {
        this.$refs.wardCodeInput.loadData();
      }
    });
  },
  watch: {
    isShowModal: function (value) {
      if (!value) {
        this.$emit("close-modal", false);
      }
    },
    dateRange: function (newValue) {
      if (newValue) {
        this.scheduleReload();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(30),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value, oldValue) {
      if (typeof oldValue === "undefined") return;
      if (this.normalizeFilterValue(value) === this.normalizeFilterValue(oldValue)) return;
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = null;
      }
      this.wardCodeInput.data.items = [];
      this.wardCodeInput.data.model = null
      this.$refs.wardCodeInput.loadData();
      this.scheduleReload();
    },
    'wardCodeInput.data.model': function (value, oldValue) {
      if (typeof oldValue === "undefined") return;
      if (this.normalizeFilterValue(value) === this.normalizeFilterValue(oldValue)) return;
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      this.scheduleReload();
    },
    'typeFileSelect.data.model': function () {
      this.scheduleReload();
    }
  },
  computed: {
    selectionIdForCompare() {
      const chosen = this.itemChooseFileSelected;
      if (
        chosen &&
        chosen !== '' &&
        chosen.id !== undefined &&
        chosen.id !== null &&
        chosen.id !== ''
      ) {
        return chosen.id;
      }
      return null;
    },
  },
};
</script>

<style>
.row-2 .form-group {
  margin-top: 0 !important;
}

#fileManagementAddSchedule .c-datatable-filter .form-control {
  min-width: 320px;
  width: 420px;
  max-width: 100%;
}

.addSchedule .modal-xl {
  max-width: 72vw;
}

@media (max-width: 991.98px) {
  .addSchedule .modal-xl {
    max-width: 96vw;
  }
}

@media (max-width: 576px) {
  .addSchedule .modal-dialog {
    margin: 0.35rem auto;
  }

  .addSchedule .modal-content {
    min-height: 96vh;
  }

  #fileManagementAddSchedule {
    max-height: none;
    overflow: visible;
  }
}

#fileManagementAddSchedule .search-panel {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

#fileManagementAddSchedule .search-panel .form-group,
#fileManagementAddSchedule .search-panel .group-select,
#fileManagementAddSchedule .search-panel .select2-container,
#fileManagementAddSchedule .search-panel .select2-selection--single,
#fileManagementAddSchedule .search-panel .form-control,
#fileManagementAddSchedule .search-panel .datepicker input {
  width: 100% !important;
}

#fileManagementAddSchedule .search-panel .search-action-col {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 0 !important;
}

#fileManagementAddSchedule .search-panel .search-action-label {
  display: block;
  height: 24px;
  margin-bottom: 0.5rem;
}

#fileManagementAddSchedule .search-panel .search-action-wrap {
  display: flex;
  justify-content: flex-end;
}

#fileManagementAddSchedule .search-panel .search-action-btn {
  margin-left: 0 !important;
}
</style>

